import React from 'react'
import { ColumnDef } from '@tanstack/react-table'
import ActionsCell from './SubsectionsAction'

interface SubSection {
	subSectionId: string
	name: string
	description: string
	questionCount: number
	sectionName: string
	userId: string
	createdBy: string
	_id: string
}

export const CustomTableColumns = (onSuccess: () => void): ColumnDef<SubSection>[] => [
	{
		accessorKey: 'sectionName',
		header: 'Section Name',
		cell: ({ row }) => (
			<div className="w-[80px]">{row.getValue<string>('sectionName')}</div>
		),
		size: 10
	},
	{
		accessorKey: 'name',
		header: 'SubSection Name',
		cell: ({ row }) => <div>{row.getValue<string>('name')}</div>
	},
	{
		accessorKey: 'description',
		header: 'Description',
		cell: ({ row }) => <div>{row.getValue<string>('description')}</div>
	},
	{
		accessorKey: 'questionCount',
		header: 'No of Questions',
		cell: ({ row }) => <div>{row.getValue<number>('questionCount')}</div>
	},
	{
		header: 'Actions',
		cell: ({ row }) => {
			return (
				<ActionsCell
					onEdit={() => console.log('Edit action')}
					onDelete={() => console.log('Delete action')}
					rowData={row.original}
					onDeleteSuccess={onSuccess}
					onEditSuccess={onSuccess}
					_id={row.original._id}
					createdBy={row.original.createdBy}
				/>
			)
		}
	}
]
